import { Link } from 'react-router-dom';
import { LISTURL } from '../config';
import { HomeIcon } from '@heroicons/react/solid';

export type BreadcrumbList = {
  name: string;
  href: string;
  current: boolean;
};

const Breadcrumb = ({ list }: { list: BreadcrumbList[] }): JSX.Element => {
  return (
    <ol className="flex items-center space-x-0.5">
      <li>
        <div>
          <Link
            to={LISTURL.general}
            className="text-gray-400 hover:text-gray-500"
          >
            <HomeIcon className="w-4 h-4" />
            <span className="sr-only">Home</span>
          </Link>
        </div>
      </li>
      {list.map(item => (
        <li key={item.name}>
          <div className="flex items-center">
            <svg
              className="flex-shrink-0 h-4 w-4 text-gray-300"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            {item.current ? (
              <span className="ml-0.5 text-xs font-medium text-gray-400">
                {item.name}
              </span>
            ) : (
              <Link
                to={item.href}
                className="ml-0.5 text-xs font-medium text-gray-500 hover:text-gray-700"
              >
                {item.name}
              </Link>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
};

export default Breadcrumb;
